export default {
  daysLeft: {
    ar: '',
    en: 'days left.'
  }
};
